var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('h6',{staticClass:"titlecolor",domProps:{"textContent":_vm._s(_vm.label)}}),_c('p',{staticClass:"mb-3 mt-1",class:_vm.value ? undefined : 'disabled--text'},[_vm._v(" "+_vm._s(_vm.value || _vm.$t('partner.na'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }